module.exports = __webpack_public_path__ + "img/404-Illustration.e7c2e960.png";